import ismobilejs from 'ismobilejs';
import queryParser from 'query-string';

export default {
    starApiPrefix: '/api/client/star', // 接星星相关接口前缀

    userApiPrefix: '/api/user', // 用户相关接口前缀

    isClient: navigator.userAgent.toLocaleLowerCase().includes('roombox'), // 是否在客户端里

    // 判断是否是移动设备
    isMobile() {
        const isMobileJs = ismobilejs();
        return isMobileJs.any;
    },
    isIos() {
        const isMobileJs = ismobilejs();
        return isMobileJs.apple.device;
    },


    // 判断是否是手机端
    isPhone() {
        const isMobileJs = ismobilejs();
        // 判断是否为手机，该方法无法判断鸿蒙系统手机
        const isMobilePhone = isMobileJs.phone; 
        const ua = window.navigator.userAgent.toLocaleLowerCase();
        // 判断鸿蒙
        const isHarmonyos = ua.indexOf('harmonyos') > -1 || ua.indexOf('openharmony') > -1;
        return isMobilePhone || isHarmonyos;
    },

    // 判断是否是平板
    isTablet() {
        const isMobileJs = ismobilejs();
        return isMobileJs.tablet;
    },

    // 获取当前客户端版本
    getClientVersion() {
        const ua = navigator.userAgent;
        try {
            return ua.split('RoomBox/')[1].split(' ')[0];
        } catch (error) {
            return '';
        }
    },

    getAddressUrl() {
        const host = window.location.host;
        if (host.includes('testd') || process.env.NODE_ENV == 'development') {
            return 'https://uc-k12studentinfo.test.xdf.cn/';
        } else {
            return 'https://uc-k12studentinfo.xdf.cn/';
        }
    },
    isTest() {
        const host = window.location.host;
        if (host.includes('testd') || process.env.NODE_ENV == 'development') {
            return true
        } 
        return false;
    },

    /**
     * 版本比较
     * @param curV 当前版本
     * @param reqV
     */
    versionCompare(curV, reqV) {
        let arr1 = curV.split('.');
        let arr2 = reqV.split('.');
        //将两个版本号拆成数字
        let maxL = Math.max(arr1.length, arr2.length);
        let pos = 0; //当前比较位
        let diff = 0; //当前为位比较是否相等
        //逐个比较如果当前位相等则继续比较下一位
        while (pos < maxL) {
            diff = (parseInt(arr1[pos]) || 0) - (parseInt(arr2[pos]) || 0);
            if (diff != 0) break;
            pos++;
        }
        if (diff >= 0) { // curV >= reqV
            return true;
        } else { // curV < reqV
            return false;
        }
    },

    // 判断系统
    validateOS() {
        const ua = navigator.userAgent;
        console.log('ua', ua);
        if (ua.indexOf("Window") > 0) {
            return "Windows";
        } else if (/iPad|iPhone|iPod/.test(ua)) {
            return "iOS";
        } else if (ua.indexOf("Mac OS X") > 0) {
            return "Mac";
        } else if (ua.indexOf("Android") > 0) {
            return "Android";
        } else if (ua.indexOf("Linux") > 0) {
            return "Linux";
        } else {
            return "NUll";
        }
    },

    // 获取当前语言
    getLanguage() {
        let language = this.getSearchParam()?.language;
        return language || navigator.language || 'en';
    },

    /**
     * 判断是否是永久有效
     * @param validTerm {Number} 有效天数
     */
    isPermanent(validTerm) {
        return validTerm >= 36500;
    },

    /**
     *  获取url参数
     */
    getSearchParam: (function() {
        let searchParams;
        if (window.location.search) {
            searchParams = queryParser.parse(window.location.search);
            for (let key in searchParams) {
              const value = searchParams[key];
              if (value instanceof Array) {
                const uniqueArr = Array.from(new Set(value));
                if (value.length !== uniqueArr.length && uniqueArr.length === 1) {
                  searchParams[key] = uniqueArr[0];
                }
              }
            }
        }
        return function() { return searchParams || {} };
    })(),
}